import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Button } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import BasicText from '../formComponents/groups/BasicText';

class BtnClickModal extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        onSubmit: PropTypes.func,
        element: PropTypes.any
    };

    submit = (values) => {
        const { onSubmit, element } = this.props;
        if (onSubmit) {
            onSubmit(element, values);
        }
    };

    render() {
        return (
            <form onSubmit={this.props.handleSubmit(this.submit)}>
                <Field component={BasicText} placeholder={'http://example.com'} label={'Link'} name={'link'} />
                <Field component={BasicText} placeholder={'My Button'} label={'Label'} name={'label'} />
                <Field
                    component={BasicText}
                    placeholder={'myClass1 myClass2'}
                    label={'Class Names'}
                    name={'classNames'}
                />
                <Button variant={'primary'} type={'submit'}>
                    Submit
                </Button>
            </form>
        );
    }
}

const BtnClickModalValidation = {
    form: 'BtnClickModal'
};

const mapStateToProps = (state, ownProps) => {
    const { element } = ownProps;
    let classNames = element.classList.toString();

    // Removing default values
    classNames = classNames.replace('verbButton', '');
    classNames = classNames.replace('btn', '');
    classNames = classNames.replace('btn-default', '');
    return {
        initialValues: {
            link: element.parentElement.getAttribute('href'),
            label: element.innerHTML,
            classNames
        }
    };
};

export default compose(connect(mapStateToProps), reduxForm(BtnClickModalValidation))(BtnClickModal);
